import { ConsoleLogger, HttpService, Query, QueryHandler, TaggedUrl, Tags, transformDTODate } from '@skylab-shared/core';
import { Transform } from 'class-transformer';

export type LaboratoryInfoContextType = 'SKYLAB_ORDERS' | 'SKYLAB_KSEF_XML';

export type LaboratoryInfoItem = LaboratoryInfoItemDTO;

class LaboratoryInfoItemDTO {
    @Transform(transformDTODate, { toClassOnly: true }) public readonly activationDate: Date;
    public readonly context: LaboratoryInfoContextType;
    public readonly name: string;
}

export class LaboratoryInfoQuery extends Query<LaboratoryInfoItem[]> { }

export class LaboratoryInfoQueryHandlerBase implements QueryHandler<LaboratoryInfoQuery, LaboratoryInfoItem[]> {
    private readonly logger = new ConsoleLogger(this.constructor.name);
    private static Url = TaggedUrl.join('system/laboratory', [Tags.Api, Tags.NotHandle5xx]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(): Promise<LaboratoryInfoItem[]> {
        try {
            const { data } = await this.http.get<LaboratoryInfoItem[]>(LaboratoryInfoQueryHandlerBase.Url, { dto: LaboratoryInfoItemDTO });
            return data;
        } catch (err) {
            this.logger.error(err);
            return [];
        }
    }
}
